"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _colors = require("../../../theme/colors");

var DropdownIndicator = function DropdownIndicator(props) {
  // eslint-disable-next-line react/prop-types
  var isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      selectProps = props.selectProps;
  var style = {
    cursor: 'pointer'
  };

  if (isDisabled) {
    style.color = _colors.text.disabled;
  } else if (isFocused) {
    style.color = _colors.text.primary;
  } else {
    style.color = _colors.text.secondary;
  }

  style.transform = selectProps.menuIsOpen ? 'rotate(180deg)' : 'none';
  return _react["default"].createElement(_reactSelect.components.DropdownIndicator, props, _react["default"].createElement(_ArrowDropDown["default"], {
    style: style
  }));
};

var _default = DropdownIndicator;
exports["default"] = _default;